import React, { useState } from 'react'
import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'
import Tooltip from 'components/Tooltip'

import { useSessionContext } from 'hooks/SessionContext'
import { useStoreContext } from 'hooks/StoreContext'

import Api from 'services/api'

const FAVORITED_ICON_PATH = '/img/bookmark.svg'
const NON_FAVORITED_ICON_PATH = '/img/bookmark-outline.svg'

type FavoriteIconProps = {
  deviceId: string
  size?: string
  className?: string | null
}

const FavoriteIcon = ({ deviceId, size = '20', className = null }: FavoriteIconProps) => {
  const { session: { userId } } = useSessionContext()
  const { favorites } = useStoreContext()

  const [isFavorited, setIsFavorited] = useState(favorites && favorites.includes(deviceId))

  return (isFavorited
    ? (
      <Tooltip title="Remove this device from the favorites list">
        <KeyboardAccessible
          className={className ?? undefined}
          onClick={() => { Api.Favorite.delete(userId, deviceId).then(() => setIsFavorited(false)) }}
        >
          <S.Icon
            src={FAVORITED_ICON_PATH}
            alt="solid bookmark icon"
            $size={size}
          />
        </KeyboardAccessible>
      </Tooltip>
    )
    : (
      <Tooltip title="Add this device to the favorites List">
        <KeyboardAccessible
          className={className ?? undefined}
          onClick={() => { Api.Favorite.create(userId, deviceId).then(() => setIsFavorited(true)) }}
        >
          <S.Icon
            src={NON_FAVORITED_ICON_PATH}
            alt="outlined bookmark icon"
            $size={size}
          />
        </KeyboardAccessible>
      </Tooltip>
    )
  )
}

export default FavoriteIcon

const S = {
  Icon: styled.img.withConfig({
    shouldForwardProp: (prop) => !['$size'].includes(prop)
  })<{ $size?: string }>`
    height: ${({ $size }) => $size}px;
    width: ${({ $size }) => $size}px;
    cursor: pointer;

    &:hover {
      background-size: ${({ $size }) => `${$size}px ${$size}px`};
      background-image: url(${FAVORITED_ICON_PATH});
    }
  `
}
